import React, { useState } from "react";
import SimpleModal from "../SimpleModal";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

const ModalBody = styled.div`
  .bold {
    font-weight: bold;
  }
  .underline {
    text-decoration: underline;
  }
  .adjusted-text-padding {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  line-height: 1.4;
`;

const ModalContent = styled.div`
  padding: 10px 20px;
`;

const ModalInput = styled.div`
  padding: 20px;
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const DetermineVersionModal = ({
  open,
  toggleModal,
  toggleReuse,
  openForm,
  version,
  setVersion,
  isReusable,
  ...props
}) => {
  const user = useSelector((state) => state.appReducer.userDataReducer.data);
  const dispatch = useDispatch();
  
  const modalText = user?.FormStatus.find(
    (item) => item?.formType === "H2A"
  )?.versionModalText;

  const resetState = () => {
    setVersion(null);
    toggleModal();
  };

  return (
    <SimpleModal
      toggleModal={toggleModal}
      modalStatus={open}
      renderButton={() => null}
      onRequestClose={resetState}
      marginRight="-5%"
    >
      <ModalBody>
        <ModalContent>
          <p className="bold" style={{ marginRight: 40 }}>
            Are you seeking to submit an H-2A Application under any of the
            following conditions?
          </p>
          <ul>
            {!!modalText?.[0] && (
              <li>
                <span className="bold underline">All</span> places of employment
                where work will be performed under the Form ETA-790/790A are
                located in one or more of the following states:
                <ul style={{ marginTop: 10 }}>
                  <li>
                    {modalText?.[0]};
                    <br />
                    <p className="bold underline adjusted-text-padding">OR</p>
                  </li>
                </ul>
              </li>
            )}
            {!!modalText?.[1] && (
              <li>
                The legal business name of the employer identified on the Form
                ETA-790/790A seeking to employ or jointly employ H-2A workers is
                “{modalText?.[1]};”
                <br />
                <ul>
                  <p className="bold underline adjusted-text-padding">OR</p>
                </ul>
              </li>
            )}
            {!!modalText?.[2] && (
              <li>
                The legal business name of the employer identified on the Form
                ETA-790/790A seeking to employ or jointly employ H-2A workers is
                a member of the “{modalText?.[2]}” as of {modalText?.[3]}.
              </li>
            )}
          </ul>
          <ModalInput>
            <input
              type="radio"
              className="usa-radio__input"
              value="2"
              id="yesRadio"
              checked={version === 2}
              onChange={(e) => setVersion(parseInt(e.target.value))}
            />
            <label className="usa-radio__label" htmlFor="yesRadio">
              Yes
            </label>
            <input
              type="radio"
              className="usa-radio__input"
              value="3"
              id="noRadio"
              checked={version === 3}
              onChange={(e) => setVersion(parseInt(e.target.value))}
            />
            <label className="usa-radio__label" htmlFor="noRadio">
              No
            </label>
          </ModalInput>
          <ModalFooter>
            <button
              type={"button"}
              disabled={!version}
              className={"usa-button usa-button-secondary"}
              onClick={() =>
                isReusable ? toggleReuse() : openForm(null, version)
              }
            >
              Continue
            </button>
          </ModalFooter>
        </ModalContent>
      </ModalBody>
    </SimpleModal>
  );
};

export default DetermineVersionModal;
